import { gql } from '@apollo/client';
import type { GraphQLRestDataSourceError } from '@cobliteam/api-lib';
import type { PageableContent, PageableContentAPI, Sort, TimestampInMillis, Trip, UUID } from '@cobliteam/common-types';
import Alert from '@cobliteam/ui/components/Alert';
import graphQLRequester from '../../request/GraphQLRequester';
import type { TripAPI } from './definitions';
import { toTripPage } from './tripTransformer';

export class GraphQLCameraTripRequester {
  private queryGetTripPage = gql`
    query getTripPage(
      $vehicleId: ID!
      $fromTimestamp: TimestampInMillis
      $toTimestamp: TimestampInMillis
      $footageAvailabilityStatus: [Boolean]
      $page: Int
      $size: Int
      $sort: [String]
    ) {
      tripsByVehicle(
        vehicleId: $vehicleId
        fromTimestamp: $fromTimestamp
        toTimestamp: $toTimestamp
        footageAvailabilityStatus: $footageAvailabilityStatus
        page: $page
        size: $size
        sort: $sort
      ) {
        content {
          id
          start_timestamp
          end_timestamp
          is_footage_available
        }
        empty
        first
        last
        number
        number_of_elements
        size
        total_elements
        total_pages
      }
    }
  `;

  public getTripPage = (
    vehicleId: UUID,
    fromTimestamp?: TimestampInMillis,
    toTimestamp?: TimestampInMillis,
    footageAvailabilityStatus?: boolean[],
    page?: number,
    size?: number,
    sort?: Sort,
    displayAlert: Boolean = true
  ): Promise<PageableContent<Trip>> =>
    graphQLRequester
      .query<{
        tripsByVehicle: PageableContentAPI<TripAPI>;
        errors: Array<GraphQLRestDataSourceError>;
      }>({
        query: this.queryGetTripPage,
        variables: {
          vehicleId,
          fromTimestamp,
          toTimestamp,
          footageAvailabilityStatus,
          page,
          size,
          sort: sort ? `startTime,${sort.order}` : null,
        },
      })
      .then((result) => {
        if (result.errors !== undefined) {
          if (displayAlert) {
            if (result.errors[0].status === 404) {
              Alert.error('O veículo solicitado não possuí viagem no último mês.');
            } else {
              Alert.error('Ops! Não foi possível encontrar trajetos para esse veículo.');
            }
          }

          throw result.errors[0];
        }
        return toTripPage(result.tripsByVehicle);
      });
}

export default GraphQLCameraTripRequester;
